import React, { useState } from 'react';
import './settings.scss';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { getSettingsData } from '../reducer';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { createCamera, saveCamera } from '../actions';
import { getResponseError } from '../../../utils/utils';
import CameraView from '../../Dashboard/components/CameraView';
import CameraDTO from '../../../dto/CameraDTO';
import CoordinateConverter from './CoordinateConverter';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';

export default function CameraForm(props) {
  const {
    selectedCamera = null, cancel, loadData = () => {}, selectCamera = () => {},
  } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  const DTO = new CameraDTO();
  const attributes = DTO.getAttributesByName();
  const dispatch = useDispatch();
  const {
    control,
    reset,
    getValues,
    setValue,
  } = useForm({
    mode: 'onBlur',
    defaultValues: selectedCamera,
    resetOptions: {
      keepDirtyValues: true, // user-interacted input will be retained
      keepErrors: true, // input errors will be retained with value update
    },
  });

  const id = selectedCamera && selectedCamera.id ? selectedCamera.id : null;

  const save = () => {
    const cam = new CameraDTO(getValues()).getCreateData();
    if (!id) {
      dispatch(createCamera(cam)).then(camera => {
        loadData();
        successNotification(formatMessage({ id: 'camera.add' }), formatMessage({ id: 'camera.add.success' }));
        reset();
        cancel();
        selectCamera(camera.id);
      }).catch(response => {
        errorNotification(formatMessage({ id: 'camera.add' }), getResponseError(response));
      });
    } else {
      dispatch(saveCamera({
        id,
        data: cam,
      })).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'camera.save' }), formatMessage({ id: 'camera.add.success' }));
      }).catch(response => {
        errorNotification(formatMessage({ id: 'camera.save' }), getResponseError(response));
      });
    }
  };

  const handleChangeCoordinate = ({ longitude = 0, latitude = 0 }) => {
    setValue('longitude', longitude);
    setValue('latitude', latitude);
  };

  return (
    <div className="settings-edit">
      <div className="settings-header">
        <div className="settings-label">{formatMessage({ id: 'menu.settings_camera' })}</div>
      </div>
      <div className="settings-form">
        <div className="camera-options settings-view-form">
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.name}
            variant="material"
          />
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={TextInputWithLabel} */}
          {/*  dtoObject={attributes.model} */}
          {/*  variant="material" */}
          {/* /> */}
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={TextInputWithLabel} */}
          {/*  dtoObject={attributes.type} */}
          {/*  variant="material" */}
          {/* /> */}
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.ip}
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.port}
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.username}
            variant="material"
          />
          <FieldDTO
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.password}
            variant="material"
          />
          {/* <FieldDTO */}
          {/*  control={control} */}
          {/*  component={TextInputWithLabel} */}
          {/*  dtoObject={attributes.password_confirmation} */}
          {/*  variant="material" */}
          {/* /> */}
          <div className="f4 mt-3 mb-3">{formatMessage({ id: 'complex.gps' })}</div>
          <div className="settings-coordinate-row mt-3">
            <FieldDTO
              control={control}
              component={TextInputWithLabel}
              dtoObject={attributes.longitude}
              variant="material"
            />
            <FieldDTO
              control={control}
              component={TextInputWithLabel}
              dtoObject={attributes.latitude}
              variant="material"
            />
            <CoordinateConverter onChange={handleChangeCoordinate} />
          </div>
        </div>
        <div className="camera">
          <div className="camera-view">
            <CameraView selectedCamera={selectedCamera} noCameraText={formatMessage({ id: 'camera.select.add' })} />
          </div>
        </div>
      </div>
      <div className="settings-footer">
        <Button className="clear-show" onClick={save}>{formatMessage({ id: 'app.save' })}</Button>
        <Button className="clear-data" variant="secondary" onClick={cancel}>{formatMessage({ id: 'app.cancel' })}</Button>
      </div>
    </div>
  );
}
